export default __webpack_public_path__ + "static/BrandonGrotesque-MediumItalic-0e7cdee61c1e44248e86abd2362f2a20.woff2";